import React from 'react';
import styled from 'styled-components';
import { Player } from '../types/multiplayer';

interface PlayerStatusDisplayProps {
  players: Player[];
  currentPlayerIndex: number;
}

const StatusContainer = styled.div`
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 16px;
  padding: 14px;
  margin-bottom: 14px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.14);
  backdrop-filter: blur(8px);
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  width: min(760px, 100%);
`;

// Use transient prop ($isActive) so React doesn't forward it to the DOM
const PlayerCard = styled.div<{ $isActive: boolean }>`
  background: ${props => props.$isActive ? 
    'linear-gradient(145deg, #E3F2FD, #BBDEFB)' : 
    'linear-gradient(145deg, #f5f5f5, #e0e0e0)'
  };
  border: 2px solid ${props => props.$isActive ? '#2196F3' : 'transparent'};
  border-radius: 12px;
  padding: 12px 10px;
  min-width: 0;
  text-align: center;
  transition: all 0.3s ease;
  
  ${props => props.$isActive && `
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);
  `}
`;
const PlayerName = styled.div<{ $isActive: boolean }>`
  font-weight: bold;
  font-size: 15px;
  color: ${props => props.$isActive ? '#1976D2' : '#333'};
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const PlayerScore = styled.div`
  font-size: 22px;
  font-weight: bold;
  color: #4CAF50;
  margin-bottom: 2px;
`;

const TurnIndicator = styled.div`
  background: #2196F3;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: bold;
  margin-top: 6px;
`;

const PlayerStatusDisplay: React.FC<PlayerStatusDisplayProps> = ({ 
  players, 
  currentPlayerIndex 
}) => {
  if (players.length === 0) return null;

  return (
    <StatusContainer>
      {players.map((player, index) => (
        <PlayerCard key={player.id} $isActive={index === currentPlayerIndex}>
          <PlayerName $isActive={index === currentPlayerIndex}>
            {player.avatar} {player.name}
          </PlayerName>
          <PlayerScore>{player.totalScore}</PlayerScore>
          <div style={{ fontSize: '12px', color: '#666' }}>poäng</div>
          {index === currentPlayerIndex && (
            <TurnIndicator>Din tur!</TurnIndicator>
          )}
        </PlayerCard>
      ))}
    </StatusContainer>
  );
};

export default PlayerStatusDisplay;
